export function getRoleLabel(role, t) {
  if (!role) return "-";
  return t ? t(`roles.${role}`, role) : role;
}
